import { render, staticRenderFns } from "./GoogleLoginButtonComponent.vue?vue&type=template&id=604511e8&scoped=true&"
import script from "./GoogleLoginButtonComponent.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLoginButtonComponent.vue?vue&type=style&index=0&id=604511e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604511e8",
  null
  
)

export default component.exports